export default {"src":"/_next/static/media/question-icon.b8380ec9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};